import React from "react";
import { sendEventTracking } from "../../utils/GeneralUtils";
import { useMetaData } from "../../utils/useMetaData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LogoImage from "../../assets/img/logo.svg";
import HeroImage from "../../assets/img/lp/hero-image.webp";
import HeroSPImage from "../../assets/img/lp/hero-image-sp.webp";
import HeroDeviceImage from "../../assets/img/lp/mock-a.webp";
import CatchphraseImage from "../../assets/img/lp/catchphrase.webp";
import IntroImage from "../../assets/img/lp/mock.webp";
import DecoNarrowLongImage from "../../assets/img/lp/decoration-narrow-long.webp";
import DecoNarrowShortImage from "../../assets/img/lp/decoration-narrow-short.webp";
import ContactBtnImage from "../../assets/img/lp/contact-btn.webp";
import RegistBtnImage from "../../assets/img/lp/regist-btn.webp";
import HexCastingImage from "../../assets/img/lp/hex-casting.webp";
import HexApparelImage from "../../assets/img/lp/hex-apparel.webp";
import HexFacilityImage from "../../assets/img/lp/hex-facility.webp";
import HexInternImage from "../../assets/img/lp/hex-intern.webp";
import HexMovieImage from "../../assets/img/lp/hex-movie.webp";
import HexPromotionImage from "../../assets/img/lp/hex-promotion.webp";
import HexRecruitImage from "../../assets/img/lp/hex-recruit.webp";
import HexSponserImage from "../../assets/img/lp/hex-sponser.webp";
import HexStaffImage from "../../assets/img/lp/hex-staff.webp";
import HexStreamingImage from "../../assets/img/lp/hex-streaming.webp";
import HexTeambuildImage from "../../assets/img/lp/hex-team-build.webp";
import HexTeammemberImage from "../../assets/img/lp/hex-team-member.webp";
import UserTypeImage from "../../assets/img/lp/type-card.webp";
import SkillImage from "../../assets/img/lp/skill-image.webp";
import TopicsImage from "../../assets/img/lp/topics-image.webp";
import PerformanceFFLHotelover from "../../assets/img/lp/performance-ffl-hotelover.webp";
import PerformanceEnrage from "../../assets/img/lp/performance-enrage.webp";
import PerformanceKinotrope2 from "../../assets/img/lp/performance-kinotrope-2.webp";
import PerformanceShinsaibashi from "../../assets/img/lp/performance-shinsaibashi.webp";
import PerformanceMeteor from "../../assets/img/lp/performance-meteor.webp";
import PerformanceWellplayed from "../../assets/img/lp/performance-wellplayed.webp";
import PerformanceMeteorAparrel from "../../assets/img/lp/meteor-aparrel.webp";
// css
import Styles from "./LandingPage.module.scss";
import SonicLink from "../../common/routing/SonicLink";

const LandingPage: React.FC = () => {
  useMetaData({
    title: "企業向けeスポーツ事業サポート SELeCT",
    description:
      "SELeCTは企業・会社と個人のeスポーツ事業をサポートします。eスポーツに関する様々な事業や企画・イベントについて、経験豊富なSELeCTのエージェントが徹底的にサポート。「これから始めたいけどどうすれば良いかわからない」「始めたけれど困っている」などあらゆる問題を解決します。",
    imgUrl: "",
  });

  return (
    <>
      <div className={Styles["lp"]}>
        <div className={Styles["lp__hero-image-area"]}>
          <div className={Styles["lp__logo"]}>
            <img src={LogoImage} alt="" />
          </div>
          <picture>
            <source srcSet={HeroSPImage} media="(max-width: 575px)" />
            <img
              src={HeroImage}
              alt="ゲームコントローラー背景画像"
              className={Styles["lp__hero-image"]}
            />
          </picture>
          <img
            src={HeroDeviceImage}
            alt="SELeCT画面イメージ"
            className={Styles["lp__hero-image-device"]}
          />
          <div className={Styles["lp__hero-content"]}>
            <img
              src={CatchphraseImage}
              alt="eスポーツへ参入するならSELeCT"
              className={Styles["lp__eye-catch-image"]}
            />
            <h1>
              SELeCTは企業・会社のeスポーツ事業への参入支援や、キャスティング・求人・アパレル制作等を行うサービスです。
            </h1>
          </div>
        </div>
        <div className={Styles["lp__bg"]}>
          <img
            src={DecoNarrowLongImage}
            alt="装飾画像"
            className={`${Styles["lp__decoration-narrow"]} ${Styles["left"]}`}
          />
          <img
            src={DecoNarrowShortImage}
            alt="装飾画像"
            className={`${Styles["lp__decoration-narrow"]} ${Styles["right"]}`}
          />
          <section>
            <div
              className={`${Styles["lp__container"]} ${Styles["lp__block"]} ${Styles["lp__intro"]}`}
            >
              <h2 className={Styles["lp__block__message"]}>
                eスポーツ事業参入でお困りの企業様へ
                <br />
                SELeCTが包括的にサポートいたします。
              </h2>
              <p className={Styles["lp__block__text"]}>
                eスポーツに関する様々な事業や企画・イベントについて、
                <br />
                経験豊富なSELeCTのエージェントが徹底的にサポート。
                <br />
                「これから始めたいけど、なにからすればいいのか...」
                <br />
                「始めたけれど、上手くいかない！」などのあらゆる問題や課題を解決します。
              </p>
              <div className={Styles["lp__block__imgbox"]}>
                <img src={IntroImage} alt="SELeCT画面イメージ" />
              </div>
              <div className={`${Styles["lp__btn-area"]}`}>
                <div className={Styles["lp__regist-merit"]}>
                  <p>
                    会員になればプロフィールから直接仕事のオファーを依頼したり、
                    <br className={Styles["visible-lg"]} />
                    プロジェクトからスタッフ募集などが可能になります。
                  </p>
                </div>
                <SonicLink
                  to="/contact"
                  className={`${Styles["lp__link"]}`}
                  onClick={() =>
                    sendEventTracking("click", "LandingPageCompany", "contact")
                  }
                >
                  <img src={ContactBtnImage} alt="お問い合わせはこちらボタン" />
                </SonicLink>
                <SonicLink
                  to="/register"
                  className={`${Styles["lp__link"]}`}
                  onClick={() =>
                    sendEventTracking("click", "LandingPageCompany", "register")
                  }
                >
                  <img src={RegistBtnImage} alt="会員登録はこちらボタン" />
                </SonicLink>
              </div>
            </div>
          </section>
        </div>
        <div className={Styles["lp__bg"]}>
          <img
            src={DecoNarrowLongImage}
            alt="装飾画像"
            className={`${Styles["lp__decoration-narrow"]} ${Styles["left"]}`}
          />
          <img
            src={DecoNarrowLongImage}
            alt="装飾画像"
            className={`${Styles["lp__decoration-narrow"]} ${Styles["left"]}`}
          />
          <img
            src={DecoNarrowShortImage}
            alt="装飾画像"
            className={`${Styles["lp__decoration-narrow"]} ${Styles["right"]}`}
          />
          <img
            src={DecoNarrowShortImage}
            alt="装飾画像"
            className={`${Styles["lp__decoration-narrow"]} ${Styles["right"]}`}
          />
          <section className={`${Styles["lp__support"]}`}>
            <div className={`${Styles["lp__container"]}`}>
              <p className={`${Styles["lp__support-heading"]}`}>
                <i></i>
                <i></i>
                <i></i>
                SELeCTのサポート内容
              </p>
              <h2 className={Styles["lp__support-title"]}>
                イベント/大会の開催について
              </h2>
              <div className={`${Styles["lp__support__list"]}`}>
                <div
                  className={`${Styles["lp__support__list-item"]} ${Styles[""]}`}
                >
                  <h3>キャスティング</h3>
                  <img src={HexCastingImage} alt="キャスティングイメージ" />
                </div>
                <div
                  className={`${Styles["lp__support__list-item"]} ${Styles[""]}`}
                >
                  <h3>
                    スタッフ
                    <br />
                    アルバイトの募集
                  </h3>
                  <img src={HexStaffImage} alt="スタッフ募集イメージ" />
                </div>
                <div
                  className={`${Styles["lp__support__list-item"]} ${Styles[""]}`}
                >
                  <h3>施設のご紹介</h3>
                  <img src={HexFacilityImage} alt="施設イメージ" />
                </div>
                <div
                  className={`${Styles["lp__support__list-item"]} ${Styles[""]}`}
                >
                  <h3>配信業者のご紹介</h3>
                  <img src={HexStreamingImage} alt="配信業者イメージ" />
                </div>
              </div>
            </div>
          </section>
          <section className={`${Styles["lp__support"]}`}>
            <div
              className={`${Styles["lp__container"]} ${Styles["lp__support"]}`}
            >
              <h2 className={Styles["lp__support-title"]}>
                eスポーツチームについて
              </h2>
              <div className={`${Styles["lp__support__list"]}`}>
                <div
                  className={`${Styles["lp__support__list-item"]} ${Styles[""]}`}
                >
                  <h3>
                    チーム設立
                    <br />
                    運営コンサルティング
                  </h3>
                  <img src={HexTeambuildImage} alt="チーム設立イメージ" />
                </div>
                <div
                  className={`${Styles["lp__support__list-item"]} ${Styles[""]}`}
                >
                  <h3>
                    チームメンバーの
                    <br />
                    募集/ご紹介
                  </h3>
                  <img src={HexTeammemberImage} alt="チームメンバーイメージ" />
                </div>
                <div
                  className={`${Styles["lp__support__list-item"]} ${Styles[""]}`}
                >
                  <h3>
                    アパレルなどの
                    <br />
                    グッズ制作
                  </h3>
                  <img src={HexApparelImage} alt="グッズイメージ" />
                </div>
                <div
                  className={`${Styles["lp__support__list-item"]} ${Styles[""]}`}
                >
                  <h3>
                    動画コンテンツの
                    <br />
                    コンサルティング
                  </h3>
                  <img src={HexMovieImage} alt="動画コンテンツイメージ" />
                </div>
              </div>
            </div>
          </section>
          <section className={`${Styles["lp__support"]}`}>
            <div className={`${Styles["lp__container"]}`}>
              <h2 className={Styles["lp__support-title"]}>
                こんなこともサポート
              </h2>
              <div className={`${Styles["lp__support__list"]}`}>
                <div
                  className={`${Styles["lp__support__list-item"]} ${Styles[""]}`}
                >
                  <h3>新卒採用の求人</h3>
                  <img src={HexRecruitImage} alt="採用イメージ" />
                </div>
                <div
                  className={`${Styles["lp__support__list-item"]} ${Styles[""]}`}
                >
                  <h3>インターンの募集</h3>
                  <img src={HexInternImage} alt="インターン募集イメージ" />
                </div>
                <div
                  className={`${Styles["lp__support__list-item"]} ${Styles[""]}`}
                >
                  <h3>
                    自社製品の
                    <br />
                    プロモーション
                  </h3>
                  <img src={HexPromotionImage} alt="プロモーションイメージ" />
                </div>
                <div
                  className={`${Styles["lp__support__list-item"]} ${Styles[""]}`}
                >
                  <h3>スポンサード先の選定</h3>
                  <img src={HexSponserImage} alt="スポンサーイメージ" />
                </div>
              </div>
              <p className={Styles["lp__support-text"]}>
                eスポーツに関するあらゆるお悩み・ご相談をお受けしております。
                <br />
                ぜひご気軽にお問合せください。
              </p>
            </div>
          </section>
        </div>
        <div className={`${Styles["lp__container"]}`}>
          <div className={`${Styles["lp__btn-area"]}`}>
            <div className={Styles["lp__regist-merit"]}>
              <p>
                会員になればプロフィールから直接仕事のオファーを依頼したり、
                <br className={Styles["visible-lg"]} />
                プロジェクトからスタッフ募集などが可能になります。
              </p>
            </div>
            <SonicLink
              to="/contact"
              className={`${Styles["lp__link"]}`}
              onClick={() =>
                sendEventTracking("click", "LandingPageCompany", "contact")
              }
            >
              <img src={ContactBtnImage} alt="お問い合わせはこちらボタン" />
            </SonicLink>
            <SonicLink
              to="/register"
              className={`${Styles["lp__link"]}`}
              onClick={() =>
                sendEventTracking("click", "LandingPageCompany", "register")
              }
            >
              <img src={RegistBtnImage} alt="会員登録はこちらボタン" />
            </SonicLink>
          </div>
        </div>
        <section
          className={`${Styles["lp__performance"]} ${Styles["lp__decoration-frame"]}`}
        >
          <div className={`${Styles["lp__container"]}`}>
            <h2 className={Styles["lp__performance-title"]}>実績</h2>
            <ul>
              <li className={Styles["lp__performance__item"]}>
                <a
                  href="https://esports-select.com/topics/62a2f309fe7181ad260f9262/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={Styles["lp__performance__link"]}
                  onClick={() =>
                    sendEventTracking(
                      "click",
                      "LandingPageCompany",
                      "実績-Meteor"
                    )
                  }
                >
                  <div className={Styles["lp__performance__imgbox"]}>
                    <img
                      src={PerformanceMeteor}
                      alt="プロeスポーツチーム「Meteor」設立の仲介のサムネイル"
                    />
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["tl"]}`}
                    ></i>
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["tr"]}`}
                    ></i>
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["bl"]}`}
                    ></i>
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["br"]}`}
                    ></i>
                  </div>
                  <div className={Styles["lp__performance__data"]}>
                    <h3 className={Styles["lp__performance__data-title"]}>
                      チーム設立サポート
                    </h3>
                    <p>プロeスポーツチーム「Meteor」設立の仲介</p>
                  </div>
                </a>
              </li>
              <li className={Styles["lp__performance__item"]}>
                <a
                  href="https://esports-select.com/topics/630e912cf2398048470e5d03/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={Styles["lp__performance__link"]}
                  onClick={() =>
                    sendEventTracking(
                      "click",
                      "LandingPageCompany",
                      "実績-KINOTOROPEキャスティング"
                    )
                  }
                >
                  <div className={Styles["lp__performance__imgbox"]}>
                    <img
                      src={PerformanceKinotrope2}
                      alt="KINOTOROPE CUPへ出演者4名をキャスティングのサムネイル"
                    />
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["tl"]}`}
                    ></i>
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["tr"]}`}
                    ></i>
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["bl"]}`}
                    ></i>
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["br"]}`}
                    ></i>
                  </div>
                  <div className={Styles["lp__performance__data"]}>
                    <h3 className={Styles["lp__performance__data-title"]}>
                      イベントキャスティング
                    </h3>
                    <p>KINOTOROPE CUPへ出演者4名をキャスティング</p>
                  </div>
                </a>
              </li>
              <li className={Styles["lp__performance__item"]}>
                <a
                  href="https://esports-select.com/topics/63166ae82be185932f00c852/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={Styles["lp__performance__link"]}
                  onClick={() =>
                    sendEventTracking(
                      "click",
                      "LandingPageCompany",
                      "実績-心斎橋パルコキャスティング"
                    )
                  }
                >
                  <div className={Styles["lp__performance__imgbox"]}>
                    <img
                      src={PerformanceShinsaibashi}
                      alt="心斎橋パルコのeスポーツイベントへキャスティングのサムネイル"
                    />
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["tl"]}`}
                    ></i>
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["tr"]}`}
                    ></i>
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["bl"]}`}
                    ></i>
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["br"]}`}
                    ></i>
                  </div>
                  <div className={Styles["lp__performance__data"]}>
                    <h3 className={Styles["lp__performance__data-title"]}>
                      イベントキャスティング
                    </h3>
                    <p>心斎橋パルコのeスポーツイベントへキャスティング</p>
                  </div>
                </a>
              </li>
              <li className={Styles["lp__performance__item"]}>
                <a
                  href="https://esports-select.com/topics/62a2ca1e224359c1990286b2/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={Styles["lp__performance__link"]}
                  onClick={() =>
                    sendEventTracking(
                      "click",
                      "LandingPageCompany",
                      "実績-協賛企業ご紹介"
                    )
                  }
                >
                  <div className={Styles["lp__performance__imgbox"]}>
                    <img
                      src={PerformanceFFLHotelover}
                      alt="eスポーツイベントへ協賛企業のご紹介のサムネイル"
                    />
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["tl"]}`}
                    ></i>
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["tr"]}`}
                    ></i>
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["bl"]}`}
                    ></i>
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["br"]}`}
                    ></i>
                  </div>
                  <div className={Styles["lp__performance__data"]}>
                    <h3 className={Styles["lp__performance__data-title"]}>
                      スポンサー紹介
                    </h3>
                    <p>eスポーツイベントへ協賛企業のご紹介</p>
                  </div>
                </a>
              </li>
              <li className={Styles["lp__performance__item"]}>
                <a
                  href="https://esports-select.com/topics/62e1054543e3a774a5097f32/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={Styles["lp__performance__link"]}
                  onClick={() =>
                    sendEventTracking(
                      "click",
                      "LandingPageCompany",
                      "実績-アルバイト求人管理"
                    )
                  }
                >
                  <div className={Styles["lp__performance__imgbox"]}>
                    <img
                      src={PerformanceWellplayed}
                      alt="eスポーツイベントへのアルバイト求人管理のサムネイル"
                    />
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["tl"]}`}
                    ></i>
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["tr"]}`}
                    ></i>
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["bl"]}`}
                    ></i>
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["br"]}`}
                    ></i>
                  </div>
                  <div className={Styles["lp__performance__data"]}>
                    <h3 className={Styles["lp__performance__data-title"]}>
                      人材紹介・求人代行
                    </h3>
                    <p>eスポーツイベントへのアルバイト求人管理</p>
                  </div>
                </a>
              </li>
              <li className={Styles["lp__performance__item"]}>
                <span
                  className={`${Styles["lp__performance__link"]} ${Styles["nolink"]}`}
                >
                  <div className={Styles["lp__performance__imgbox"]}>
                    <img
                      src={PerformanceEnrage}
                      alt="eスポーツ企業のインターン募集のサムネイル"
                    />
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["tl"]}`}
                    ></i>
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["tr"]}`}
                    ></i>
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["bl"]}`}
                    ></i>
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["br"]}`}
                    ></i>
                  </div>
                  <div className={Styles["lp__performance__data"]}>
                    <h3 className={Styles["lp__performance__data-title"]}>
                      人材紹介・求人代行
                    </h3>
                    <p>eスポーツ企業のインターン募集</p>
                  </div>
                </span>
              </li>
              <li className={Styles["lp__performance__item"]}>
                <span
                  className={`${Styles["lp__performance__link"]} ${Styles["nolink"]}`}
                >
                  <div className={Styles["lp__performance__imgbox"]}>
                    <img
                      src={PerformanceMeteorAparrel}
                      alt="eスポーツチームMeteorのアパレルグッズ制作のサムネイル"
                    />
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["tl"]}`}
                    ></i>
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["tr"]}`}
                    ></i>
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["bl"]}`}
                    ></i>
                    <i
                      className={`${Styles["lp__performance__deco"]} ${Styles["br"]}`}
                    ></i>
                  </div>
                  <div className={Styles["lp__performance__data"]}>
                    <h3 className={Styles["lp__performance__data-title"]}>
                      アパレル制作代行
                    </h3>
                    <p>eスポーツチームMeteorのアパレルグッズ制作</p>
                  </div>
                </span>
              </li>
              <li className={Styles["lp__performance__item"]}>
                <SonicLink
                  to="/topics/?topic_type=SELeCT実績"
                  className={`${Styles["lp__performance__link"]} ${Styles["other"]}`}
                  onClick={() =>
                    sendEventTracking(
                      "click",
                      "LandingPageCompany",
                      "実績-その他"
                    )
                  }
                >
                  その他は実績はこちら
                </SonicLink>
              </li>
            </ul>
          </div>
        </section>
        <div className={`${Styles["lp__container"]}`}>
          <div className={`${Styles["lp__btn-area"]}`}>
            <div className={Styles["lp__regist-merit"]}>
              <p>
                会員になればプロフィールから直接仕事のオファーを依頼したり、
                <br className={Styles["visible-lg"]} />
                プロジェクトからスタッフ募集などが可能になります。
              </p>
            </div>
            <SonicLink
              to="/contact"
              className={`${Styles["lp__link"]}`}
              onClick={() =>
                sendEventTracking("click", "LandingPageCompany", "contact")
              }
            >
              <img src={ContactBtnImage} alt="お問い合わせはこちらボタン" />
            </SonicLink>
            <SonicLink
              to="/register"
              className={`${Styles["lp__link"]}`}
              onClick={() =>
                sendEventTracking("click", "LandingPageCompany", "register")
              }
            >
              <img src={RegistBtnImage} alt="会員登録はこちらボタン" />
            </SonicLink>
          </div>
        </div>
        <section
          className={`${Styles["lp__type"]} ${Styles["lp__decoration-frame"]}`}
        >
          <div className={`${Styles["lp__container"]}`}>
            <h2 className={Styles["lp__type-title"]}>
              2,000人以上の多彩な登録ユーザー
            </h2>
            <p>
              SELeCTに登録している様々なユーザーからお探しの条件に合う人材がきっと見つかります。
              <br />
              ライブラリから最適な人材をSELeCTよりご提案するなどのサポートも行っております。
            </p>
            <img src={UserTypeImage} alt="ユーザータイプイメージ" />
            <p>登録いただいてるユーザータイプの一例</p>
            <ul className={Styles["lp__type-list"]}>
              <li>アイドル</li>
              <li>アナリスト</li>
              <li>イラストレーター</li>
              <li>エンジニア</li>
              <li>オーガナイザー</li>
              <li>オブザーバー</li>
              <li>コーチ</li>
              <li>サウンドクリエイター</li>
              <li>スタッフ</li>
              <li>ストリーマー</li>
              <li>タレント</li>
              <li>チーム</li>
              <li>チームオーナー</li>
              <li>デザイナー</li>
              <li>プレイヤー</li>
              <li>プロデューサー</li>
              <li>マネージャー</li>
              <li>ライター</li>
              <li>声優</li>
              <li>実況者</li>
              <li>監督</li>
              <li>映像クリエイター</li>
            </ul>
          </div>
        </section>
        <div className={Styles["lp__bg"]}>
          <p className={`${Styles["lp__support-heading--center"]}`}>
            個人ユーザーの方はこちら
          </p>
          <img
            src={DecoNarrowLongImage}
            alt="装飾画像"
            className={`${Styles["lp__decoration-narrow"]} ${Styles["left"]}`}
          />
          <img
            src={DecoNarrowShortImage}
            alt="装飾画像"
            className={`${Styles["lp__decoration-narrow"]} ${Styles["right"]}`}
          />
          <section>
            <div
              className={`${Styles["lp__container"]} ${Styles["lp__block"]}`}
            >
              <h2 className={Styles["lp__block__message"]}>
                あなたのスキルが活きる
                <br />
                eスポーツを仕事に！
              </h2>
              <div className={Styles["lp__block__text"]}>
                <p>
                  これまで遊びのひとつだったゲームが、これからは仕事・職業の選択肢として拡がっていきます。
                  <br />
                  SELeCTが提供しているサービスは、全ての会員が共通で利用することができます。
                  <br />
                  業種・職種に関わらずeスポーツ活動や仕事をしたい皆さまのご登録をお待ちしています。
                </p>
                <ul className={Styles["lp__block__list"]}>
                  <li>
                    <FontAwesomeIcon icon={["fal", "check-square"]} />
                    自身のスキルを活かした仕事を探す
                  </li>
                  <li>
                    <FontAwesomeIcon icon={["fal", "check-square"]} />
                    eスポーツを就職・転職・副業の選択肢にする
                  </li>
                  <li>
                    <FontAwesomeIcon icon={["fal", "check-square"]} />
                    活動の協力者を探す
                  </li>
                  <li>
                    <FontAwesomeIcon icon={["fal", "check-square"]} />
                    自身のプレイスキルをアピールして仕事に繋げる
                  </li>
                  <li>
                    <FontAwesomeIcon icon={["fal", "check-square"]} />
                    eスポーツ活動の実績を増やしたい
                  </li>
                </ul>
                <p>
                  プロフィールを公開して自身のスキルや実績をアピールできます。
                </p>
              </div>
              <div
                className={`${Styles["lp__block__imgbox"]} ${Styles["skill"]}`}
              >
                <img src={SkillImage} alt="ユーザースキルイメージ" />
              </div>
            </div>
          </section>
        </div>
        <div className={Styles["lp__bg"]}>
          <img
            src={DecoNarrowLongImage}
            alt="装飾画像"
            className={`${Styles["lp__decoration-narrow"]} ${Styles["left"]}`}
          />
          <img
            src={DecoNarrowShortImage}
            alt="装飾画像"
            className={`${Styles["lp__decoration-narrow"]} ${Styles["right"]}`}
          />
          <section>
            <div
              className={`${Styles["lp__container"]} ${Styles["lp__block"]} ${Styles["topics-area"]}`}
            >
              <h2 className={Styles["lp__block__message"]}>
                eスポーツ情報も発信中
              </h2>
              <p className={Styles["lp__block__text"]}>
                定期的に公開されるeスポーツトピックス。
                <br />
                内容は攻略情報やゲーム紹介、eスポーツに関するコラム、製品紹介など多岐にわたります。
              </p>
              <div
                className={`${Styles["lp__block__imgbox"]} ${Styles["topics"]}`}
              >
                <img src={TopicsImage} alt="トピックス画面イメージ" />
              </div>
              <p className={Styles["lp__block__text"]}>
                情報を掲載することでeスポーツに興味のあるユーザーの目に留まることが期待できます。
                <br />
                情報発信源のひとつとしてご利用ください。
              </p>
            </div>
          </section>
        </div>
        <div
          className={`${Styles["lp__finaly"]} ${Styles["lp__decoration-frame"]}`}
        >
          <div
            className={`${Styles["lp__btn-area"]} ${Styles["lp__container"]}`}
          >
            <div className={Styles["lp__regist-merit"]}>
              <p>eスポーツ事業に興味がある企業様は是非一度ご相談を！</p>
            </div>
            <SonicLink
              to="/contact"
              className={`${Styles["lp__link"]}`}
              onClick={() =>
                sendEventTracking("click", "LandingPageCompany", "contact")
              }
            >
              <img src={ContactBtnImage} alt="お問い合わせはこちらボタン" />
            </SonicLink>
            <SonicLink
              to="/register"
              className={`${Styles["lp__link"]}`}
              onClick={() =>
                sendEventTracking("click", "LandingPageCompany", "register")
              }
            >
              <img src={RegistBtnImage} alt="会員登録はこちらボタン" />
            </SonicLink>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingPage;
